import React from 'react';
import { useEffect, useState } from 'react'

import { CustomerCardModel } from './models/CustomerCardModel';
import { SimulatorModel } from './models/SimulatorModel';
import { useSelector, useDispatch } from 'react-redux'
import './assets/css/emails.css'
import { Menu } from './_Menu'
import Header from './Header';
import Footer from './_Footer'
//import RenewalsManagement from './SystemManagement/_renewalsManagement'
//import './assets/css/systemManagement.css'
import RenewalsManagement from './SystemManagement/_renewalsManagement'
import './assets/css/systemManagement.css'
import ProductionMenegement from './SystemManagement/_productionManagement'
import SimulatorSettings from './simulator/settings/SimulatorSettings'
import UsersManagement from './SystemManagement/_usersManagement'
import GroupsManagement from './SystemManagement/_groupsManagement'
import BranchesManagement from './SystemManagement/_branchesManagement'
import ProjectsManagement from './SystemManagement/_projectsManagement'
import RidersManagement from './SystemManagement/_ridersManagement'
import RiderServicesManagement from './SystemManagement/_riderServicesManagement'


const SystemManagement = () => {

    const [renewalsActive, setRenewalsActive] = useState<boolean>(false);
    const [productionActive, setProductionActive] = useState<boolean>(false);
    const [simulatorSettingsActive, setSimulatorSettingsActive] = useState<boolean>(true);
    const [usersActive, setUsersActive] = useState<boolean>(false);
    const [groupsActive, setGroupsActive] = useState<boolean>(false);
    const [branchesActive, setBranchesActive] = useState<boolean>(false);
    const [projectsActive, setProjectsActive] = useState<boolean>(false);
    const [ridersActive, setRidersActive] = useState<boolean>(false);
    const [riderServicesActive, setRiderServicesActive] = useState<boolean>(false);

    useEffect(() => {

    },
        []);


        // Activate one tab and reset all the others. Each tab gets its own helper
        // so the JSX onClick handlers stay readable.
        const activateOnly = (tab: string) => {
            setRenewalsActive(tab === 'renewals');
            setProductionActive(tab === 'production');
            setSimulatorSettingsActive(tab === 'simulator');
            setUsersActive(tab === 'users');
            setGroupsActive(tab === 'groups');
            setBranchesActive(tab === 'branches');
            setProjectsActive(tab === 'projects');
            setRidersActive(tab === 'riders');
            setRiderServicesActive(tab === 'riderServices');
        };

        const activeProduction = async () => activateOnly('production');
        const activeRenewlas = async () => activateOnly('renewals');
        const activeSimulatorSettings = async () => activateOnly('simulator');
        const activeUsers = async () => activateOnly('users');
        const activeGroups = async () => activateOnly('groups');
        const activeBranches = async () => activateOnly('branches');
        const activeProjects = async () => activateOnly('projects');
        const activeRiders = async () => activateOnly('riders');
        const activeRiderServices = async () => activateOnly('riderServices');


    // documents end

    return (
<div className='main-content rtl'>
              <Menu activePage='Leads' />
              <div className='center-content'>
                <Header PageName="ניהול מערכת" />
                <div className='lleads'>
                 <section className="main-body"></section>
<div className="">
            <div className="emails-tab-row">
                {/* <div className={`email-tab email-tab-clients ${renewalsActive?"selected":""}`}>
                    <div className="top-border" ></div>
                    <div className="tab-content" onClick={()=>activeRenewlas()}><div className="label">חידושים</div>
                    </div>
                </div>
                <div className={`email-tab email-tab-view-message ${productionActive?"selected":""}`}>
                    <div className="top-border"></div>
                    <div className="tab-content" onClick={()=>activeProduction()}>
                        <div className="label" >פרודוקציה</div>

                    </div>
                </div> */}
                <div className={`email-tab email-tab-view-message ${simulatorSettingsActive?"selected":""}`}>
                    <div className="top-border"></div>
                    <div className="tab-content" onClick={()=>activeSimulatorSettings()}>
                        <div className="label" >הגדרות סימולטור</div>

                    </div>
                </div>
                <div className={`email-tab email-tab-view-message ${usersActive?"selected":""}`}>
                    <div className="top-border"></div>
                    <div className="tab-content" onClick={()=>activeUsers()}>
                        <div className="label" >משתמשים</div>

                    </div>
                </div>
                <div className={`email-tab email-tab-view-message ${groupsActive?"selected":""}`}>
                    <div className="top-border"></div>
                    <div className="tab-content" onClick={()=>activeGroups()}>
                        <div className="label" >קבוצות</div>

                    </div>
                </div>
                <div className={`email-tab email-tab-view-message ${branchesActive?"selected":""}`}>
                    <div className="top-border"></div>
                    <div className="tab-content" onClick={()=>activeBranches()}>
                        <div className="label" >סניפים</div>

                    </div>
                </div>
                <div className={`email-tab email-tab-view-message ${projectsActive?"selected":""}`}>
                    <div className="top-border"></div>
                    <div className="tab-content" onClick={()=>activeProjects()}>
                        <div className="label" >פרויקטים</div>

                    </div>
                </div>
                <div className={`email-tab email-tab-view-message ${ridersActive?"selected":""}`}>
                    <div className="top-border"></div>
                    <div className="tab-content" onClick={()=>activeRiders()}>
                        <div className="label" >חבילות Rider</div>

                    </div>
                </div>
                <div className={`email-tab email-tab-view-message ${riderServicesActive?"selected":""}`}>
                    <div className="top-border"></div>
                    <div className="tab-content" onClick={()=>activeRiderServices()}>
                        <div className="label" >שירותי Rider</div>

                    </div>
                </div>
            </div>
        </div>
        <div className='body'>
            {renewalsActive?<RenewalsManagement></RenewalsManagement>:""}
            {productionActive?<ProductionMenegement></ProductionMenegement>:""}
            {simulatorSettingsActive?<SimulatorSettings></SimulatorSettings>:""}
            {usersActive?<UsersManagement></UsersManagement>:""}
            {groupsActive?<GroupsManagement></GroupsManagement>:""}
            {branchesActive?<BranchesManagement></BranchesManagement>:""}
            {projectsActive?<ProjectsManagement></ProjectsManagement>:""}
            {ridersActive?<RidersManagement></RidersManagement>:""}
            {riderServicesActive?<RiderServicesManagement></RiderServicesManagement>:""}

        </div>
                  
                  <footer className="footer emails-list-footer emails-list-view">
                    
                  </footer>

                </div>
              </div>
              </div>








        

    )
}

export default SystemManagement;

export {};